var map = {
	"./feature-icon-1.svg": "0625",
	"./feature-icon-2.svg": "c6b9",
	"./feature-icon-3.svg": "d67b",
	"./feature-icon-4.svg": "d963",
	"./feature-icon-5.svg": "17fa",
	"./feature-icon-6.svg": "2cbc",
	"./features-bg.svg": "0d66",
	"./intro-bg.svg": "4c42",
	"./join-bg-desktop.svg": "13e7",
	"./join-bg-mobile.svg": "eb8d",
	"./products-section-bg.svg": "befe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "176f";